import React, { useState, useEffect, useCallback } from "react";
import Login from "./components/auth/Login";
import Navigation from "./components/nav/Navigation";
import Inventory from "./components/inventory/Inventory";
import Reports from "./components/reports/Reports";
import Settings from "./components/settings/Settings";
import Transactions from "./components/transactions/Transactions";
import Footer from "./components/footer/Footer";
import MyAccount from "./components/account/MyAccount";
import Home from "./components/home/Home";
import "./App.css";

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => {
    const storedLoggedInStatus = localStorage.getItem("isLoggedIn");
    return storedLoggedInStatus === "true";
  });

  const [loggedInUser, setLoggedInUser] = useState(() => {
    const storedUser = localStorage.getItem("loggedInUser");
    if (storedUser && storedUser !== "undefined" && storedUser !== "null") {
      try {
        const parsedUser = JSON.parse(storedUser);
        console.log(
          "App.js: Initial loggedInUser from localStorage:",
          parsedUser
        );
        return parsedUser;
      } catch (e) {
        console.error("Error parsing stored user from localStorage:", e);
        localStorage.removeItem("loggedInUser");
        localStorage.removeItem("isLoggedIn");
        return null;
      }
    }
    console.log("App.js: No loggedInUser found in localStorage on init.");
    localStorage.removeItem("loggedInUser");
    localStorage.removeItem("isLoggedIn");
    return null;
  });

  const [currentPage, setCurrentPage] = useState("home");

  useEffect(() => {
    if (isLoggedIn && loggedInUser) {
      setCurrentPage("home");
    } else {
      setCurrentPage("home");
    }
  }, [isLoggedIn, loggedInUser]);

  const getAuthHeaders = useCallback(() => {
    const token = localStorage.getItem("authToken");
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  }, []);

  const handleLogin = (user) => {
    console.log("App.js: User received from Login component:", user);
    setIsLoggedIn(true);
    setLoggedInUser(user);
    setCurrentPage("home");

    localStorage.setItem("isLoggedIn", "true");
    localStorage.setItem("loggedInUser", JSON.stringify(user));
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleUserUpdate = (updatedUser) => {
    setLoggedInUser(updatedUser);
    localStorage.setItem("loggedInUser", JSON.stringify(updatedUser));
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setLoggedInUser(null);
    setCurrentPage("home");

    localStorage.removeItem("authToken");
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("loggedInUser");

    // Optional: Reload the page to clear all state
    window.location.reload();
  };

  const renderPage = () => {
    switch (currentPage) {
      case "transactions":
        return (
          <Transactions
            getAuthHeaders={getAuthHeaders}
            onLogout={handleLogout}
            loggedInUser={loggedInUser}
          />
        );
      case "inventory":
        return (
          <Inventory getAuthHeaders={getAuthHeaders} onLogout={handleLogout} />
        );
      case "reports":
        return (
          <Reports getAuthHeaders={getAuthHeaders} onLogout={handleLogout} />
        );
      case "settings":
        return (
          <Settings getAuthHeaders={getAuthHeaders} onLogout={handleLogout} />
        );
      case "my-account":
        return (
          <MyAccount
            loggedInUser={loggedInUser}
            onUserUpdate={handleUserUpdate}
            getAuthHeaders={getAuthHeaders}
            onLogout={handleLogout}
          />
        );
      case "home":
      default:
        return <Home />;
    }
  };

  return (
    <div className="App-container">
      {!isLoggedIn ? (
        <>
          <Home />
          <Login onLogin={handleLogin} />
        </>
      ) : (
        <>
          <Navigation
            onNavigate={handlePageChange}
            loggedInUser={loggedInUser}
            onLogout={handleLogout}
          />
          <div className="main-content-area">{renderPage()}</div>
          <Footer />
        </>
      )}
    </div>
  );
}

export default App;
